// JSON.parse for the body of a checked response. A body the check has already reported comes back
// as null when it does not parse, since an error would say less than the report. Any other body that
// does not parse throws an error that, unlike the browser's own, does not quote the body.
export default function parseJson(text, problem) {
  try {
    return JSON.parse(text);
  } catch {
    if (problem) {
      return null;
    }

    throw new SyntaxError("Response body is not valid JSON");
  }
}
